import styles from "./footer.module.scss";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <footer className={styles.footer}>
            <Link to="/" className={styles.brandText}>
                <img
                    src="/disco_white.png"
                    alt="Disco"
                    className={styles.logo}
                /> Invitify 2025
            </Link>
            <p className={styles.creditText}>
                Crafted by{' '}
                <a
                    href="https://stidl.io"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.link}
                >
                    Stidl
                </a>
                <br />
                <a
                    href="mailto:thomas@stidl.io"
                    className={styles.link}
                >
                    thomas@stidl.io
                </a>
            </p>
        </footer>
    );
}

export default Footer;
